module.exports = __webpack_public_path__ + "static/media/SketchPng97bd6484c07dd9c82b8607c479db9689016b5695a7eb7b25b581c94a46bc88cc.e946a225.png";